module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-tokai-3-1d0970671e6903f41a76c73e7d185d1d.png";